module.exports = __webpack_public_path__ + "static/media/play.04db15d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/player-controls/play.svg
// module id = 253
// module chunks = 0